/**
 * Composer Enter-key helpers.
 *
 * Linux/IME keyboards sometimes omit `event.key` or fire Enter while an
 * input method is composing. Treat those as "not a send Enter" so we do
 * not change the default Mac/Windows "Enter sends" behavior.
 */
/**
 * Enter-to-send is a physical-keyboard desktop behavior. iPad is never
 * phone-width, so `!isXS` used to enable RN `submitBehavior: 'submit'`, which
 * blurs the field as the software keyboard appears.
 */
export function shouldComposerSendOnEnter({
  isXS = false,
  isPad = false,
  isMobileOrTablet = false,
  enterToSend,
} = {}) {
  if (isXS || isPad || isMobileOrTablet) return false;
  return enterToSend !== false;
}

export function isComposerEnterEvent(event) {
  if (!event) return false;
  if (event.isComposing || event.nativeEvent?.isComposing) return false;

  const keyCode = event.keyCode ?? event.which
    ?? event.nativeEvent?.keyCode ?? event.nativeEvent?.which;
  // 229 = IME composition; the real Enter arrives after composition ends.
  if (keyCode === 229) return false;

  const key = event.key || event.nativeEvent?.key;
  const code = event.code || event.nativeEvent?.code;
  return key === 'Enter' || code === 'Enter' || code === 'NumpadEnter' || keyCode === 13;
}
